<template>
  <v-menu left bottom offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on" class="mr-0">
        <v-avatar color="secondary" size="40">
          <img :src="avatarSource" />
        </v-avatar>
      </v-btn>
    </template>
    <v-list class="m-t-3">
      <v-list-item
        v-for="(item, index) in items"
        :key="`item-${index}`"
        @click="item.cb"
      >
        <v-list-item-title>
          <v-icon v-text="item.icon" />
          {{ $t(item.name) }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { call, get } from 'vuex-pathify'

export default {
  name: 'ItemBarProfile',
  computed: {
    avatarSource: get('user/avatarSource'),
    items() {
      const vm = this
      return [
        {
          icon: 'mdi-account',
          name: 'Profile',
          cb: () => {
            vm.$router.push({ name: 'profile.index' }).catch(err => { console.log(err) })
            return false
          }
        },
        {
          icon: 'mdi-logout',
          name: 'Logout',
          cb: () => {
            vm.logout()
          }
        }
      ]
    }
  },
  methods: {
    logout: call('auth/logout')
  }
}
</script>
